<template>
  <div class="row">
    <model-index
      ref="table"
      class="col-12"
      :loading="loading"
      v-bind="$props"
      :columns="columns"
      :busy.sync="busy"
      :models-paginated="modelsPaginated"
      :models="models"
      :page.sync="page"
      :per-page.sync="perPage"
      :from="from"
      :total="totalFiltered"
      :search.sync="search"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :empty-state-title="$t('unloads.empty_state.title')"
      empty-state-subtitle=" "
      @create-click="handleCreate"
      @show-click="handleShow"
      @edit-click="handleEdit"
      @delete-click="handleDelete"
    >
      <template #card-tools>
        <b-button v-if="models.length" variant="primary" size="sm" @click="handleRedirectCreate">
          {{ $t('unloads.empty_state.action') }}
        </b-button>
      </template>
      <template #emptyStateAction>
        <div class="d-flex justify-content-center">
          <b-button variant="primary" @click="handleRedirectCreate">
            {{ $t('unloads.empty_state.action') }}
          </b-button>
        </div>
      </template>
    </model-index>
  </div>
</template>

<script>
import ModelChildIndex from "../../models/children/index";

export default {
  extends: ModelChildIndex,
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("unloads.plural"));
      }
    },
    resourceRoute: { default: "unloads" },
    modelVariable: { default: "unload" },
    tableMinHeight: { type: Number, default: 85.5 }, // 42.5 + 43
    tableHeight: { type: Number, default: 214.5 }, // 42.5 + (43 * 4)
    denyCreate: { type: Boolean, default: true },
    hideTableHeader: { type: Boolean, default: true },
    parentFilterKey: { type: String, default: "sales_plan_id__in" },
    values: {
      type: Array,
      default() {
        return [];
      }
    },
    showProps: {
      default() {
        return {
          cardTitle: this.lodash.startCase(this.$t("unloads.singular")),
          resourceRoute: "unloads",
          modelVariable: "unload",
          denyEdit: true,
          denyDelete: true
        };
      }
    }
  },
  data() {
    return {
      sortBy: "id",
      sortDesc: true
    };
  },
  computed: {
    resolvedSalesPlanId() {
      return this.parentFilterKey === "sales_plan_id__in"
        ? this.parent.id || this.$route.params.key
        : (this.parent.sales_plan || {}).id;
    },
    columns() {
      return {
        ["unload"]: [
          {
            key: "id",
            label: "ID Nota Bongkar",
            thStyle: { minWidth: "125px" },
            component: {
              props: ["item"],
              template: '<router-link :to="`/unloads/${item.id}`">{{ `${item.id}` }}</router-link>'
            }
          },
          {
            key: "trip_id",
            label: "ID Armada",
            thStyle: { minWidth: "100px" },
            component: {
              props: ["item"],
              template: '<router-link v-if="item.trip_id" :to="`/trips/${item.trip_id}`">{{ `${item.trip_id}` }}</router-link><span v-else>-</span>'
            }
          },
          {
            key: "ordered_at",
            label: "Tanggal Nota Bongkar",
            thStyle: { minWidth: "150px" },
            formatter: value => this.$moment.utc(value).local().format("DD MMM YYYY")
          },
          {
            key: "sale_item_total_quantity",
            label: "Biomasa Bongkar",
            thStyle: { minWidth: "100px" },
            thClass: "text-end",
            tdClass: "text-end",
            formatter: value =>
                value >= 500
                    ? `${this.$numeral(value / 1000).format("0,0.[000]")} ${this.$t("units.ton")}`
                    : `${this.$numeral(value).format("0,0.[000]")} ${this.$t("units.kg")}`
          },
          {
            key: "sale_item_total",
            label: "Total Harga Bongkar",
            thStyle: { minWidth: "100px" },
            thClass: "text-end",
            tdClass: "text-end",
            component: {
              props: ["item"],
              template: '<div><template v-if="!item.is_draft">{{$numeral(item.total).format("$ 0,0.[00]")}}</template><span v-else style="color: #D19C00">Nota Timbang</span></div>'
            }
          },
          {
            key: "customer.name",
            label: this.lodash.startCase(this.$t('unloads.destination_processing_plant')),
          },
          {
            key: "creator.name",
            label: "Dibuat Oleh",
          },
        ]
      };
    }
  },
  methods: {
    fetchModels(page = 1) {
      return this.$axios
          .get("/sale_orders", {
            params: {
              page: page,
              per_page: this.perPage,
              search: this.search,
              searchables: "unload",
              with: [
                "creator",
                "customer",
                "ticket",
                "ticketable",
                "sale_items",
                "sale_items.purchase_item",
                "trip"
              ].join(","),
              sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
              type__in: "unload,cash,harvest,deposit_goods",
              [this.parentFilterKey]: [this.parent.id || this.$route.params.key],
              ...this.filterParams
            }
          })
          .then(response => {
            const {
              data: { data, meta }
            } = response;
            this.models = data.map(datum => ({
              ...datum,
              _denyShow: false,
              _denyEdit: true,
              _denyDelete: true
            }));
            this.page = Number(meta.current_page);
            this.perPage = Number(meta.per_page);
            this.from = Number(meta.from);
            this.total = Number(meta.total);

            this.stats = [];

            return response;
          })
          .catch(error => {
            this.failedAlert(error);
            return null;
          });
    },
    handleRedirectCreate() {
      this.$router.push({
        path: "/unloads/create",
        query: {
          sales_plan_id: this.resolvedSalesPlanId
        }
      });
    }
  }
};
</script>
